import { combineReducers } from 'redux';
import menuLocations from './menuLocations';
import nearbyRegion from './nearbyRegion';
import pages from './pages';
import poi from './poi';
import region from './region';

export default combineReducers({
  menuLocations,
  nearbyRegion,
  pages,
  poi,
  region,
});



// WEBPACK FOOTER //
// ./src/reducers/cms/index.js